import { Form, useFormikContext } from "formik";
import { Button, Divider, Icon, Form as SForm } from 'semantic-ui-react';


export function FormWithButtons({ handleSubmit, children }: { handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void, children: React.ReactNode }) {
  const { setFieldValue } = useFormikContext<any>();
  return (
    <SForm as={Form} onSubmit={(event) => {
      event.preventDefault();

      const submitter = (event.nativeEvent as any)?.submitter;
      // console.log('__submitter', submitter);

      if (submitter && submitter.name) {
        setFieldValue('__submitter', submitter.name);
      }
      // event.preventDefault();
      handleSubmit(event);
    }}>
      <div>
        {/* Form fields go here */}
        {children}
        <Divider/>
        <Button
          primary
          size="large"
          name="execute-search"
          type='submit'
          // onClick={executeSearch}
          // loading={isSearching}
          // disabled={isSearching}
          data-testid="execute-search-button"
        >
          <Icon name="search" />
          {'Search'}
        </Button>
        <Button
          name="add-criteria"
          type="submit"
          positive
          size="large"
          // onClick={onAddCurrentParams ? () => onAddCurrentParams({ ...values, discriminator }) : undefined}
          // disabled={getAvailableSearchTypes().length === 0}
          data-testid="add-criteria-button"
        >
          <Icon name="plus" />
          Add Search Criteria
        </Button>
      </div>
    </SForm>
  );
}
